<template>
  <div class="basedatetimepicker">
    <div class="basedatetimepicker__fillin">
      <label>{{ label }}</label>
      <el-date-picker
        :value="datetime"
        @input="input"
        @blur="clicked = true"
        format="yyyy-MM-dd HH:mm"
        value-format="yyyy-MM-dd HH:mm"
        default-time="12:00:00"
        type="datetime"
        clearable
        :disabled="disabled"
        :class="{ required: requiredValid }"
        placeholder="選擇日期時間"
      >
        <!-- :picker-options="pickerOptions" -->
      </el-date-picker>
    </div>
    <p v-if="requiredValid" class="form-error-messgae">此欄位日期與時間必填</p>
  </div>
</template>

<script>
import { toUTC } from '@/utils/moment.js';

export default {
  name: 'BaseDateTimePicker',
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: [Date, String],
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      clicked: false,
      pickerOptions: {
        disabledDate: time => {
          const SecondsOfDay = 60 * 60 * 24 * 1000;
          return time.getTime() + SecondsOfDay < new Date().getTime();
        }
      }
    };
  },
  methods: {
    input(value) {
      const utc = this.formatToUTC(value);
      this.$emit('input', utc);
    },
    formatToUTC(datetime) {
      if (!datetime) return;
      const date = datetime.split(' ')[0];
      const time = datetime.split(' ')[1];
      return toUTC(date, time);
    }
  },
  computed: {
    requiredValid() {
      return !this.disabled && this.required && !this.value && this.clicked;
    },
    datetime() {
      return this.value ? new Date(this.value) : '';
    }
  }
};
</script>

<style lang="scss" scoped>
.basedatetimepicker {
  &__fillin {
    display: flex;
    align-items: center;
  }
  label {
    flex: 0 1 80px;
    margin-bottom: 0;
  }
  .b-form-btn-label-control.form-control {
    flex: 1 0 200px;
    height: 38px;
  }
  &__icon {
    width: 20px;
  }
}

.widerlabel {
  label {
    flex: 0 0 100px;
  }
}

::v-deep .el-input.is-disabled .el-input__inner {
  background-color: #e9ecef;
  border-color: $border-soft;
  color: $text-regular;
}

::v-deep .el-input__prefix,
.el-input__suffix {
  color: $text-regular;
}

::v-deep .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}

::v-deep .el-input__inner {
  border-color: #c0c3c4;
}

::v-deep .required .el-input__inner {
  border-color: #f00;
}
</style>
